import React from 'react';
import { Desk } from '@features/desks/services/DeskBookingService';
import { BodyRegular, BodySmall, BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import styled from "styled-components";
import { Row } from '@shared/ui/atoms/StructuralLayout';
import TextField, { TextFieldProps } from '@shared/ui/atoms/TextField';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import Colours from '@shared/ui/atoms/Colours';
import { useTranslation } from "react-i18next";
import { OfficeManagementPanelView } from "../../office-management-page-v2/data/OfficeManagement.model";
import { useDispatch } from "react-redux";
import {
  setActiveOfficeManagementPanel,
  setFocusedChildOffice
} from '@features/desks/store/editOfficeLayout.duck';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';

export function ManageDeskControl(props: Props) {
  const {desks, parentOffice} = props;
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const onClicked = () => {
    dispatch(setFocusedChildOffice(parentOffice));
    dispatch(setActiveOfficeManagementPanel(OfficeManagementPanelView.DeskManagement));
  }

  if (desks.length === 0) {
    return <ManageDeskControlContainer>
      <BodyRegular weight={600}>{t('settings.manage-desk.create-desk')}</BodyRegular>
      <BodySmall style={{marginBottom: 16}}>{t('settings.manage-desk.message-1')}</BodySmall>
      <EditDeskButton>
        <OutlineButton click={onClicked}
                       fullWidth={true}
                       text={"textinput.add-individual-desks"} />
      </EditDeskButton>
    </ManageDeskControlContainer>
  } else {
    return <ManageDeskControlContainer>
      <BodyRegular weight={600}>{t('settings.manage-desk.create-desk')}</BodyRegular>
      <BodySmall style={{marginBottom: 16}}>{t('settings.manage-desk.message-1')}</BodySmall>
      <BodyVerySmall colour={Colours.darkGrey}
                     style={{marginBottom: 4}}
                     weight={600}>{t('settings.manage-desk.number-of-desks')}</BodyVerySmall>
      <Row style={{alignItems: 'center'}}>

        <SmallTextField onChange={() => {}}
                   disabled={true}
                   dataTest={'desks-capacity-field'}
                   value={`${desks.filter((d: Desk) => d.active).length}`} />

        <EditDeskButton>
          <OutlineButton click={onClicked}
                         fullWidth={true}
                         text={"textinput.desk-names-and-avail"} />
        </EditDeskButton>

      </Row>
    </ManageDeskControlContainer>
  }
}

interface Props {
  desks: Desk[];
  isEditable: boolean;
  parentOffice: OfficeEntity;
}

const ManageDeskControlContainer = styled.div`
  margin-bottom: 48px;
`;

const EditDeskButton = styled.div`
  width: 250px;
  max-width: 250px;
  margin-right: 16px;
`;

const SmallTextField = styled(TextField)<TextFieldProps>`
  max-width: 50px;
  margin: 0 16px 0 0;
  input {
    text-align: center;
  }
`;
